export type DataNeed = "api" | "public" | "file" | "local";

export interface NavLeaf {
	label: string;
	href: string;
	/** Short text shown to the right in the dropdown. */
	hint?: string;
}

export interface NavItem {
	label: string;
	href: string;
	children?: NavLeaf[];
	/** Paths that highlight this item besides its own. */
	also?: string[];
}

// The one place nav labels live. /dashboard, /users and /terminal stay routed but are
// deliberately not listed, so they are reachable by URL only and highlight nothing.
export const NAV: NavItem[] = [
	{ label: "Markets", href: "/" },
	{
		label: "Flags",
		href: "/flagged",
		children: [
			{ label: "Flagged Positions", href: "/flagged" },
			{ label: "Flow by Market", href: "/flagged/flow" },
		],
	},
	{
		label: "Whales",
		href: "/whales",
		children: [
			{ label: "Large Trades", href: "/whales" },
			{ label: "Overview", href: "/whales/overview" },
		],
	},
	{
		label: "Traders",
		href: "/smart-money",
		children: [
			{ label: "Top Traders", href: "/smart-money" },
			{ label: "Scored Wallets", href: "/wallets" },
			{ label: "Copy Candidates", href: "/smart-money/copy" },
			{ label: "Segments report", href: "/segments" },
		],
	},
	{ label: "Watchlist", href: "/watchlist" },
];

const under = (path: string, href: string) => path === href || path.startsWith(`${href}/`);

/** Index of the top-level nav item that owns `path`, or -1 (pure). */
export function activeNavIndex(path: string): number {
	if (path === "/") return 0;
	return NAV.findIndex((item) => {
		if (item.href === "/") return false;
		if (under(path, item.href)) return true;
		if (item.also?.some((p) => under(path, p))) return true;
		return item.children?.some((c) => under(path, c.href)) ?? false;
	});
}

/** The longest child href matching `path`, so /whales/overview does not also light /whales. */
export function activeLeaf(path: string, item: NavItem): string | null {
	const hits = (item.children ?? []).filter((c) => under(path, c.href));
	return hits.sort((a, b) => b.href.length - a.href.length)[0]?.href ?? null;
}
